import React from 'react'
import Col from 'muicss/lib/react/col'
import Row from 'muicss/lib/react/row'
import Avatar from './Avatar'
import Medals from './Medals'
import MedalDialog from '../MedalDialog'
import Missions from './Missions'
import MissionDialog from '../MissionDialog'
import MyPrizes from './MyPrizes'
import LvlExpCredits from './LvlExpCredits'

const style = { backgroundColor: '#ffffff' }

class Profile extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      medalOpen: false,
      missionOpen: false,
      prizeOpen: false,
    }
  }

  missionToggleOpen = () => {
    this.setState({
      missionOpen: !this.state.missionOpen,
    })
  }

  prizeToggleOpen = () => {
    this.setState({
      prizeOpen: !this.state.prizeOpen,
    })
  }

  medalToggleOpen = () => {
    this.setState({
      medalOpen: !this.state.medalOpen,
    })
  }


  render() {
    return (
      <Row style={style}>
        <Col xs="12">
          <Avatar />
        </Col>
        <Col xs="12">
          <LvlExpCredits />
        </Col>
        <Col xs="12" >
          <Medals toggleOpen={this.medalToggleOpen} />
          <MedalDialog toggleOpen={this.medalToggleOpen} open={this.state.medalOpen} />
        </Col>
        <br />
        <Col xs="12">
          <Missions toggleOpen={this.missionToggleOpen} />
          <MissionDialog toggleOpen={this.missionToggleOpen} open={this.state.missionOpen} />
        </Col>
        <Col xs="12">
          <MyPrizes />
        </Col>
      </Row>
    )
  }
}

export default Profile



// WEBPACK FOOTER //
// ./src/components/Main/Profile/index.jsx